import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../views/layout/index.vue";
import Register from "../views/register/index.vue";
import Home from "../components/Home.vue";
import Solution from "../components/Solution.vue";
import Product from "../components/Product.vue";
import Technology from "../components/Technology.vue";

const routes = [{
  path: "/login",
  name: "login",
  component: () =>
    import(/* webpackChunkName: "login" */ "@/views/login/index.vue")
},{
  path: "/",
  component: Layout,
  redirect: "/",
  children:[
    {
      path: '/',
      component: Home,
      meta: {
        showFoot: true,
        requireAuth: false
      }
    }, {
      path: '/solution',
      component: Solution,
      name: 'solution',
      meta: {
        showFoot: true,
        requireAuth: false
      }
    }, {
      path: '/product',
      component: Product,
      meta: {
        showFoot: true,
        requireAuth: false
      }
    }, {
      path: '/technology',
      component: Technology,
      meta: {
        showFoot: true,
        requireAuth: false
      }
    }, {
      path: '/register',
      component: Register,
      redirect: '/register/sealRegister',
      children:[{
        path: 'sealRegister',
        name: 'sealRegister',
        component: () =>
          import(/* webpackChunkName: "seal_register" */ "@/views/seal_register/index.vue"),
        meta: {
          showFoot: false,
          requireAuth: true
        }
      },{
        path: 'infoModify',
        name: 'infoModify',
        component: () =>
          import(/* webpackChunkName: "info_modify" */ "@/views/info_modify/index.vue"),
        meta: {
          showFoot: false,
          requireAuth: true
        }
      },{
        path: 'modifyRecord',
        name: 'modifyRecord',
        component: () =>
          import(/* webpackChunkName: "modify_record" */ "@/views/modify_record/index.vue"),
        meta: {
          showFoot: false,
          requireAuth: true
        }
      },{
        path: 'doModify',
        name: 'doModify',
        component: () =>
          import(/* webpackChunkName: "do_modify" */ "@/views/do_modify/index.vue"),
        meta: {
          showFoot: false,
          requireAuth: true
        }
      },{
        path: 'sealOperation',
        name: 'sealOperation',
        component: () =>
          import(/* webpackChunkName: "seal_operation" */ "@/views/seal_operation/index.vue"),
        meta: {
          showFoot: false,
          requireAuth: true
        }
      }]
    }
  ]
}]

const scrollBehavior = function (to, from, savePosition) {
  if (to.hash) {
    return {
      selector: to.hash
    }
  }
}

Vue.use(VueRouter)

const router = new VueRouter({
  routes,
  scrollBehavior,
  mode: 'hash'
})

router.afterEach(function () {
  window.scrollTo(0, 0);
});

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
    if(JSON.parse(window.sessionStorage.getItem('user'))){ //判断本地是否存在access_token
      next();
    }else {
      next({
        path:'/login'
      })
    }
  }
  else {
    next();
  }
  /*如果本地存在登录信息，则不允许直接跳转到登录页面*/
  if(to.fullPath == "/login"){
    if(JSON.parse(window.sessionStorage.getItem('user'))){
      next({
        path:from.fullPath
      });
    }else {
      next();
    }
  }
});

export default router




// WEBPACK FOOTER //
// ./src/router/index.js